export const State = {
  OUTSIDE: 0,
  ONP1: 1,
  ONP2: 2,
  TRANSLATINGP1: 3,
  TRANSLATINGP2: 4,
  ONLINE: 5,
  SCALING: 6,
};

export const Restrict = {
  NONE: 0,
  X: 1,
  Y: 2,
  Z: 3,
};

export default {
  State,
  Restrict,
};
